import { api } from './api';

/** Public (no-auth) unsubscribe flow backed by an HMAC-signed token. */
export const unsubscribeApi = {
  preview: async (token: string): Promise<{ email: string }> => {
    const r = await api.get<{ email: string }>('/api/unsubscribe', { params: { token } });
    return r.data;
  },
  confirm: async (token: string): Promise<{ ok: boolean; email: string }> => {
    const r = await api.post<{ ok: boolean; email: string }>('/api/unsubscribe', { token });
    return r.data;
  },
};
